import { useEffect } from 'react'
import localStorage from '../localStorage'

export default function useLocalStorage(key, value, setValue) {
  useEffect(() => {
    const item = localStorage.getItem(key)
    if (item) {
      setValue(JSON.parse(item))
    }
  }, [])

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value))
  }, [value])
}
